import MetricBase from "models/metrics/MetricBase";
import PerformanceGroup from "models/groups/PerformanceGroup";
import i18n from "i18next";
import PercentUnit from "models/metrics/unit/PercentUnit";

class MetricGenerated extends MetricBase {
    constructor() {
        super({
            field: "metric_generated",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.google_hotel_ads.generated.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads.generated.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads.generated.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricGenerated;
